<template>
  <Header app clipped-left :userInfo="user" :appName="appName" />
</template>

<script>
import { Header } from '@locaweb/design-system-vue'
import { authStore } from '@/store/auth'
import { PROJECT_TITLE } from '@/consts'

export default {
  name: 'DefaultLayout',
  components: {
    Header
  },
  computed: {
    user () {
      return authStore().userInfo
    },
    appName () {
      return PROJECT_TITLE
    }
  }
}
</script>
